import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { RESPONSE } from '@shared/tokens/server.token';
import { Response } from 'express';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(
    private languageService: LanguageService,
    private router: Router,
    @Inject(PLATFORM_ID) private _platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response
  ) {}

  redirect(
    path: string,
    code: 301 | 302 = 302,
    lang?: string,
    queryParams?: any
  ) {
    const lng = lang ?? this.languageService.userSelectedLanguage.code;
    const lngPath = `${lng ? lng + '/' : ''}${path}`;

    if (isPlatformServer(this._platformId)) {
      this.response?.redirect(code, `/${lngPath}`);
    } else {
      this.router.navigate([lngPath], {
        queryParams,
        queryParamsHandling: 'preserve',
      });
    }
  }
}
